(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["puffin-basket-reminder"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize(root) {
    root.querySelectorAll('[data-pbr]').forEach(panel => {
      const form = panel.closest('form');
      if (!form || panel.dataset.pbrReady) return;
      panel.dataset.pbrReady = 'true';
      const email = panel.querySelector('[data-pbr-email]');
      const refuse = panel.querySelector('[data-pbr-refuse]');
      const receipt = panel.querySelector('[data-pbr-receipt]');
      const error = panel.querySelector('.pbr__error');
      function clearError() {
        email.removeAttribute('aria-invalid');
        error.hidden = true;
        receipt.value = '';
      }
      email.addEventListener('input', clearError);
      refuse.addEventListener('change', clearError);
      form.addEventListener('submit', event => {
        receipt.value = '';
        const address = email.value.trim().toLowerCase();
        if (!address) return;
        if (!email.validity.valid || /[\r\n]/.test(address)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          email.setAttribute('aria-invalid', 'true');
          error.hidden = false;
          email.focus();
          return;
        }
        try {
          const items = JSON.parse(panel.querySelector('[data-pbr-items]').textContent);
          if (!Array.isArray(items) || !items.length || items.length > 100) return;
          receipt.value = JSON.stringify({
            version: panel.dataset.pbrVersion,
            purpose: 'one_basket_reminder',
            source: 'cart_page_checkout_submit',
            language: panel.dataset.pbrLanguage,
            notice: panel.querySelector('[data-pbr-notice]').textContent.trim(),
            refusalLabel: panel.querySelector('[data-pbr-refusal-text]').textContent.trim(),
            email: address,
            refused: refuse.checked,
            capturedAt: new Date().toISOString(),
            renderedAt: Number(panel.dataset.pbrRenderedAt),
            receiptId: crypto.randomUUID(),
            items
          });
        } catch (_) {
          receipt.value = '';
        }
      }, true);
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["puffin-signup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('puffin-signup');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const visitKey = 'puffin_signup_visit_v1';
  const subscriberKey = 'puffin_signup_subscribed_v1';
  const idleLimit = 30 * 60 * 1000;
  let memoryVisit = null;
  let timer;
  const readVisit = () => {
    try { return JSON.parse(localStorage.getItem(visitKey)) || memoryVisit; }
    catch (_) { return memoryVisit; }
  };
  const saveVisit = visit => {
    memoryVisit = visit;
    try { localStorage.setItem(visitKey, JSON.stringify(visit)); } catch (_) {}
  };
  const isSubscribed = () => {
    try { return localStorage.getItem(subscriberKey) === 'true'; } catch (_) { return false; }
  };
  const now = Date.now();
  let visit = readVisit();
  if (!visit || typeof visit.startedAt !== 'number' || typeof visit.lastActivity !== 'number' || now - visit.lastActivity >= idleLimit) {
    visit = { startedAt: now, lastActivity: now, shown: false };
  }
  visit.lastActivity = now;
  saveVisit(visit);
  dialog.querySelectorAll('[data-pfs-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  if (dialog.querySelector('[data-pfs-success]')) {
    try { localStorage.setItem(subscriberKey, 'true'); } catch (_) {}
    dialog.showModal();
    return;
  }
  if (dialog.querySelector('[data-pfs-errors]')) { dialog.showModal(); return; }
  if (isSubscribed() || visit.shown || window.Shopify?.designMode) return;
  const showOffer = () => {
    const current = readVisit() || visit;
    if (isSubscribed() || current.shown) return;
    const focused = document.activeElement;
    if (document.hidden || document.querySelector('dialog[open], .modal[aria-hidden="false"]') || focused?.matches('input, textarea, select, [contenteditable="true"]')) {
      timer = window.setTimeout(showOffer, 5000);
      return;
    }
    current.shown = true;
    current.lastActivity = Date.now();
    saveVisit(current);
    dialog.showModal();
  };
  timer = window.setTimeout(showOffer, Math.max(0, 20000 - (now - visit.startedAt)));
  let lastTouch = now;
  const touchVisit = () => {
    const touched = Date.now();
    if (touched - lastTouch < 15000) return;
    lastTouch = touched;
    const current = readVisit() || visit;
    current.lastActivity = touched;
    saveVisit(current);
  };
  ['pointerdown', 'keydown', 'scroll'].forEach(name => window.addEventListener(name, touchVisit, { passive: true }));
  window.addEventListener('pagehide', () => { window.clearTimeout(timer); touchVisit(); });
  window.addEventListener('storage', event => {
    if (event.key === subscriberKey && event.newValue === 'true') { window.clearTimeout(timer); if (dialog.open) dialog.close(); }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
